var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "968233EE-9FE5-4744-98A5-D683B29CB4A8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "QA-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-Product-Code-Unavailable",
    transform: "translate(-1011.000000, -245.000000)",
    fill: "#787878",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(389.000000, 225.428669)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Close",
    points: "624.18346 31.3746878 627.973437 26.6973311 631.763415 31.3746878 633.498437 31.3746878 628.785576 25.7475621 633.301556 20.3246878 631.554228 20.3246878 627.961132 24.8080058 624.368037 20.3246878 622.633014 20.3246878 627.148994 25.7475621 622.448437 31.3746878"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.39d4f978402ecea5f2efece94d053020.svg";
export { ForwardRef as ReactComponent };